import { UploadedFile } from "./app.models";

export interface ViewDidEnter {
  ionViewDidEnter(): void;
}
export interface ViewDidLeave {
  ionViewDidLeave(): void;
}
export interface ViewCanEnter {
  ionViewCanEnter(): void;
}


export interface ApiViewData {
  loading?: boolean,
  totalItems?: number,
  pages?: {
    current: string,
    next?: string,
    previous?: string,
    last: string
  }
}

export interface ApiCollectionResponse {
  items: any[],
  view: ApiViewData
}

export interface LoginData {
  email: string,
  password: string,
  rememberLogin: boolean
}

export interface ResetPasswordData {
  token: string,
  password: string
}
export interface AcceptInvitationData {
  token: string,
  firstName: string
  lastName: string
  email: string
  password?: string
}

export interface TokenResponse {
  token: string,
  refresh_token?: string,
}

export interface DecodedToken {
  exp: number,
  iat: number,
  roles: string[],
  username: string,
  user: User
}

export interface User {
  id: number,
  email: string,
  firstName: string,
  lastName: string,
  fullName: string,
  avatar: string,
  avatarFile?: UploadedFile,
	description: string,
  userGroup?: string,
  admin?: boolean,
  enabled?: boolean,
  notificationSettings?: any,
  statistics: {
    posts: number,
    reactions: number,
    bestReactions: number
  }
}

export interface UserGroup {
  id: number,
  name: string,
  abbreviation: string,
  description: string,
  icon: string,
  active: boolean,
  users?: User[],
  usersCount?: number,
  statistics: {
    posts: number,
    reactions: number
  }
}

export interface Category {
  id: number,
  title: string,
  active?: boolean,
  statistics: {
    posts: number,
    reactions: number
  }
}

export interface Tag {
  id?: number,
  title: string,
  active?: boolean,
}

export interface Post {
  id?: number,
  user?: User,
  title: string,
  anonymous: boolean,
  created?: string,
  reactionsCount?: number,
  content: string,
  updated?: string,
  reactions?: PostReaction[],
  userGroups: UserGroup[],
  categories?: Category[],
  tags?: Tag[],
  userHasModeratingAccess?: boolean,
  userFavourite?: boolean,
  published?: boolean,
  attachments?: UploadedFileInfo[],
}

export interface PostReaction {
  id?: number,
  user?: User,
  content: string,
  created?: string,
  best?: boolean,
  hasChildBest?: boolean,
  published?: boolean,
	userHasModeratingAccess?: boolean,
	upvotesCount?: number,
  upvotes?: User[],
	userHasUpvoted?: boolean,
  attachments?: UploadedFileInfo[],
  reactions?: PostReaction[],
  reactionsCount?: number

}

export interface PostAndPostReaction {
  post: Post,
  postReaction: PostReaction
}

export interface NavigationParams {
  shortcut?: string,
  route?: string,
  params?: any,
  parentRoute?: string,
  parentParams?: any,
  push?: boolean
  pop?: boolean,
  popTo?: string
}

export interface Notification {
  id: number,
	type?: string,
  message: string,
	created: string,
	read: boolean,
	archived?: boolean,
	originatingUser?: User,
  navigationParams?: NavigationParams
}

export interface UploadedFileInfo {
  fileName: string;
  extension: string;
  origFileName: string;
  type: string;
}

export const UserGroupIcons: string[] = [
	'auto_blauw',
	'auto_groen',
	'auto_oranje',
	'auto_paars',
	'auto_rood',
	'auto_roze',
	'heli_groen',
	'heli_oranje',
	'heli_rood',
	'koffer_blauw',
	'pet_blauw',
	'slang_groen',
  'hart_rood',
  'hersenen_blauw',
  'stethoscoop_geel',
	'stuur_oranje',
  'koptelefoon_roze',
	'users_paars',
];

export interface Report {
  id?: number,
  post?: Post,
  postReaction?: PostReaction,
  message?: string
  user?: User,
  created?: string
}

export interface Feedback {
  id?: number,
  url: string,
  owner?: User,
  created?: string,
  description: string
}

export interface UserInvite {
  fullName: string,
  email: string,
  firstName?: string,
  lastName?: string
}

export interface DirectMessage {
  id: number,
  from: string,
  to: string,
  content: string,
  attachments?: any[],
  created?: string
}

export interface Conversation {
  with: string,
  lastMessage: string,
  amount: number,
  fullName: string,
  avatar: string
}

export interface MessagesGroup {
  messages: DirectMessage[],
  date: Date
}

export interface DropdownItem {
  title: string,
  metadata?: any
}



// WEBPACK FOOTER //
// ./src/app/app.interfaces.ts